import ExcelCertificate from '../assets/Excel Skills for Business Specialization.webp';
import PowerBICertificate from '../assets/Microsoft Power BI Data Analyst.webp';
import SqlCertificate from '../assets/Learn SQL Basics for Data Science.webp';
import ProcurementCertificate from '../assets/Advanced Global Procurement and Sourcing.webp';
import UnileverCertificate from '../assets/Unilever Supply Chain Data Analyst.webp';
import SupplyChainCertificate from '../assets/Supply Chain Management Specialization.webp';

const certificationsData = [
  {
    title: 'Excel Skills for Business Specialization',
    image: ExcelCertificate,
    alt: 'Excel Skills for Business Specialization certificate',
    description: 'Macquarie University, Sydney Australia. Completed a 4-course online specialization covering Excel Essentials, Intermediate I, Intermediate II, and Advanced Excel for business reporting, dashboard creation, large dataset management, advanced formulas, automation, and forecasting.',
    link: 'https://coursera.org/verify/specialization/SO8XLFZDDLKE',
  },
  {
    title: 'Microsoft Power BI Data Analyst',
    image: PowerBICertificate,
    alt: 'Microsoft Power BI Data Analyst certificate',
    description: 'Microsoft 8-course professional certificate focused on Power BI data analysis, BI reporting, data modelling, DAX, visualization, dashboard development, ETL, deployment, capstone project work, and PL-300 exam preparation.',
    link: 'https://coursera.org/verify/professional-cert/TL43KY389E09',
  },
  {
    title: 'Learn SQL Basics for Data Science',
    image: SqlCertificate,
    alt: 'Learn SQL Basics for Data Science certificate',
    description: 'UC Davis 3-course specialization focused on SQL query fluency for data science and analysis, covering SQL basics, data wrangling, problem solving, query writing, analysis datasets, and a capstone project.',
    link: 'https://coursera.org/verify/specialization/XLWTEPDG4HUI',
  },
  {
    title: 'Advanced Global Procurement and Sourcing',
    image: ProcurementCertificate,
    alt: 'Advanced Global Procurement and Sourcing certificate',
    description: 'Rutgers University 7-course specialization focused on global procurement, sourcing strategy, supplier partnerships, procurement technology, ESG, supplier diversity, and risk reduction through commodity and currency hedging.',
    link: 'https://coursera.org/verify/specialization/WTZD07871C8J',
  },
  {
    title: 'Unilever Supply Chain Data Analyst',
    image: UnileverCertificate,
    alt: 'Unilever Supply Chain Data Analyst certificate',
    description: 'Unilever Professional Certificate in progress, focused on job-ready supply chain data analytics, decision-making, operational reporting, inventory visibility, procurement insights, and performance monitoring using data-driven methods.',
  },
  {
    title: 'Supply Chain Management Specialization',
    image: SupplyChainCertificate,
    alt: 'Supply Chain Management Specialization certificate',
    description: 'Rutgers University specialization in progress, focused on logistics, operations, planning, sourcing, supply chain strategy, procurement, inventory, demand planning, and end-to-end strategic decision-making.',
  },
];

export default certificationsData;
